import { useCallback, useContext, useEffect, useState, useRef, memo, MutableRefObject } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  slotProps: {
    paper: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  },
};

interface OptionType {
  key: string;
  value: string;
}

type Props = {
  onChange: (value: string[]) => void;
  options: OptionType[];
  selected: string[];
}

const BorgStyleMultiSelect = ( props: Props ) => {
  const [selectedState, setSelectedState] = useState<string[]>(props.selected);
  const selectedRef = useRef<string[]>(props.selected);

  useEffect(() => {}, [selectedRef]);

  const handleSelect = (event: SelectChangeEvent<string[]>) => {
    let selected = typeof event.target.value === 'string' ? event.target.value.split(',') : event.target.value;
    setSelectedState(selected);
    selectedRef.current = selected;
  };

  const handleUnfocus = () => {
    props.onChange(selectedRef.current);
  };

  return (
    <div tabIndex={0}>
      <FormControl sx={{display: 'flex', m: 1, width: 300 }}>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectedRef.current}
          onChange={event => handleSelect(event)}
          input={<OutlinedInput />}
          renderValue={selected =>
            selected.map(key => {
              const option = props.options.find(option => option.key === key);

              return option?.value ??
                (key === '00000000-0000-0000-0000-000000000000'
                  ? 'Unassigned'
                  : 'Unavailable instructor');
            }).join(', ')
          }
          MenuProps={MenuProps}
          onBlur={handleUnfocus}
        >
          {props.options.map((option, index) => {
            const isSelected = selectedRef.current.includes(option.key);
            const SelectionIcon = isSelected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

            return (
              <MenuItem key={option.key} value={option.key}>
                <SelectionIcon
                  fontSize="small"
                  style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                />
                <ListItemText primary={option.value} />
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};

export default BorgStyleMultiSelect;